import axios from 'axios';
import Cookies from 'universal-cookie';

const SigliveServiceSSE = axios.create({
  // REACT_APP_SSE apply in production only
  baseURL: `${process.env.REACT_APP_SSE ?? process.env.REACT_APP_API_URL ?? ''}api/v1`,
});

SigliveServiceSSE.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const token = cookies.get('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default SigliveServiceSSE;
